<div
  class="payment-status-container"
  [class.success-bg]="confirmedSuccess"
  [class.neutral-bg]="!confirmedSuccess">
  <mat-card
    class="status-card"
    [class.success]="confirmedSuccess"
    [class.neutral]="!confirmedSuccess && !loadingSession">

    <!-- Confirmed success. Payment is already done, so this card stays up while orders are created. -->
    <ng-container *ngIf="confirmedSuccess">
      <div class="icon-container">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h1>{{ isFreeOrder ? 'Free Order Confirmed!' : 'Payment successful!' }}</h1>
      <p class="lead" *ngIf="isFreeOrder && fulfillmentPhase === 'complete'">
        Your campaign has been scheduled. Enjoy your complimentary radio advertisement!
      </p>
      <p class="lead" *ngIf="isFreeOrder && fulfillmentPhase === 'progress'">
        We're finalizing your free order — this usually takes only a moment.
      </p>
      <p class="lead" *ngIf="!isFreeOrder && fulfillmentPhase === 'progress'">
        Your payment was received. We're creating an order for each campaign.
      </p>
      <p class="lead" *ngIf="!isFreeOrder && fulfillmentPhase === 'partial'">
        Your payment was received. {{ orders.length }} {{ orders.length === 1 ? 'order is' : 'orders are' }} ready. Still creating the rest.
      </p>
      <p class="lead" *ngIf="!isFreeOrder && fulfillmentPhase === 'complete' && cartCheckout">
        Your campaigns have been scheduled. Each one has its own order and receipt.
      </p>
      <p class="lead" *ngIf="!isFreeOrder && fulfillmentPhase === 'complete' && !cartCheckout">
        Your campaign has been scheduled. It will appear in My Orders shortly.
      </p>
      <p class="lead fulfillment-note" *ngIf="fulfillmentPhase === 'stopped'">
        {{ stoppedMessage }}
        <a routerLink="/orders" class="orders-link">View my orders</a>
      </p>

      <div class="order-box" *ngIf="orderSummary">
        <h2>Order details</h2>
        <div class="row" *ngIf="!cartCheckout && fulfillmentPhase === 'complete' && orderSummary.orderId">
          <span class="label">Order ID</span>
          <span class="value">#{{ orderSummary.orderId }}</span>
        </div>
        <div class="row" *ngIf="!cartCheckout && fulfillmentPhase === 'progress' && !orderSummary.orderId">
          <span class="label">Order ID</span>
          <span class="value chip-pending">Creating…</span>
        </div>
        <div class="row" *ngIf="orderSummary.amount != null && !isFreeOrder">
          <span class="label">Amount paid</span>
          <span class="value">{{ formatMoney(orderSummary.amount!, orderSummary.currency || 'USD') }}</span>
        </div>
        <div class="row" *ngIf="isFreeOrder">
          <span class="label">Amount paid</span>
          <span class="value chip-success">$0.00 — Free promotional order</span>
        </div>
        <div class="row" *ngIf="orderSummary.status">
          <span class="label">Status</span>
          <span class="value chip-success">{{ orderSummary.status }}</span>
        </div>

        @if (cartCheckout && fulfillmentPhase === 'progress') {
          <div class="orders-inline-loader">
            <app-data-loader [show]="true" message="Creating your orders…" size="medium" />
          </div>
        }
        @if (cartCheckout && orders.length > 0) {
          <div class="purchase-orders">
            @for (order of orders; track order.id) {
              <div class="purchase-order">
                <div class="purchase-order-main">
                  <span class="purchase-station">{{ stationLabel(order) }}</span>
                  <span class="purchase-id">Order #{{ order.id }}</span>
                </div>
                @if (order.total_cost != null) {
                  <span class="purchase-cost">{{ formatMoney(order.total_cost, orderSummary.currency || 'USD') }}</span>
                } @else {
                  <span></span>
                }
                @if (isRegularUser) {
                  <button
                    class="btn-secondary purchase-receipt"
                    type="button"
                    (click)="downloadReceipt(order.id)"
                    [disabled]="downloadingOrderId === order.id">
                    @if (downloadingOrderId === order.id) {
                      <span>Generating…</span>
                    } @else {
                      <span>Download Receipt</span>
                    }
                  </button>
                }
              </div>
            }
            @if (fulfillmentPhase === 'partial') {
              <p class="purchase-pending">Creating the remaining order…</p>
            }
          </div>
        }
      </div>

      <mat-divider *ngIf="orderSummary" class="divider"></mat-divider>

      <div class="actions">
        <button mat-flat-button color="primary" class="cta" (click)="goToOrders()">View my orders</button>
        <ng-container *ngIf="isRegularUser && !cartCheckout && fulfillmentPhase === 'complete' && orderSummary?.orderId">
          <button
            class="btn-secondary"
            type="button"
            (click)="downloadReceipt(orderSummary!.orderId!)"
            [disabled]="isDownloadingReceipt"
            [attr.aria-busy]="isDownloadingReceipt">
            @if (isDownloadingReceipt) {
              <span class="btn-spinner-dark" aria-hidden="true"></span>
              <span>Generating…</span>
            } @else {
              <mat-icon aria-hidden="true">download</mat-icon>
              <span>Download Receipt (PDF)</span>
            }
          </button>
        </ng-container>
      </div>
    </ng-container>

    <!-- Payment is still being processed (ACH / bank transfer) -->
    <ng-container *ngIf="!confirmedSuccess && processingUi">
      <div class="loading-block subtle">
        <app-data-loader [show]="true" message="Confirming payment…" size="medium" />
        <h1 class="neutral-title">Finalizing your order</h1>
        <p class="lead" *ngIf="orderSummary?.amount != null">
          {{ formatMoney(orderSummary!.amount!, orderSummary!.currency || 'USD') }} — We're confirming your payment with our servers. This usually takes only a moment.
        </p>
        <p class="lead" *ngIf="orderSummary?.amount == null">
          We're confirming your payment with our servers. This usually takes only a moment.
        </p>
      </div>
      <div class="actions">
        <button mat-stroked-button type="button" (click)="refreshSession()">Refresh status</button>
        <button mat-flat-button color="primary" class="cta" (click)="goToOrders()">My orders</button>
      </div>
    </ng-container>

  </mat-card>
</div>
